import React, { useMemo } from 'react'
import { Header as BaseHeader } from '../Shared'
import { useNewTranslation } from 'hooks'
import { TASK_TYPE_ENUM } from 'services/api/constants'

interface HeaderProp {
    taskType: TASK_TYPE_ENUM
}

const Header: React.FC<HeaderProp> = ({ taskType }) => {
    const [t] = useNewTranslation()

    const title = useMemo(() => {
        let key = ''
        switch (taskType) {
            case TASK_TYPE_ENUM.PURCHASE_PRODUCT:
                key = 'campaignEditor.createTask.fiilInfoProductPurchaseHeader'
                break
            case TASK_TYPE_ENUM.ATTEND_EVENT:
                key = 'campaignEditor.createTask.fillInfoAttendEventHeader'
                break
            case TASK_TYPE_ENUM.IG_POST:
            case TASK_TYPE_ENUM.IG_POST_V02:
                key = 'campaignEditor.createTask.fillInfoInstagramPostHeader'
                break
            case TASK_TYPE_ENUM.IG_STORY:
            case TASK_TYPE_ENUM.IG_STORY_V02:
                key = 'campaignEditor.createTask.fillInfoInstagramStoryHeader'
                break
            case TASK_TYPE_ENUM.IG_REEL:
                key = 'campaignEditor.createTask.fillInfoInstagramReelHeader'
                break
            case TASK_TYPE_ENUM.FB_POST:
            case TASK_TYPE_ENUM.FB_POST_V02:
                key = 'campaignEditor.createTask.fillInfoFacebookPostHeader'
                break
            case TASK_TYPE_ENUM.TIKTOK_POST:
                key = 'campaignEditor.createTask.fillInfoTikTokHeader'
                break
            case TASK_TYPE_ENUM.XIAOHONGSHU_POST:
                key = 'campaignEditor.createTask.fillInXHSPostInformationTitle'
                break
        }

        return t(key)
    }, [taskType, t])

    return <BaseHeader title={title} subtitle={t('campaignEditor.createTask.fillInfoPageSubtitle')} />
}

export default Header
